// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__oDSms","row":"ProcedureTreatmentSummary_row__1Rv-V"};